import React, { useCallback, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import "./MainPage.css";
// import Header from "../../layouts/header/Header";
import Sidebar from "../../layouts/sidebar/Sidebar";
import Header from "../../layouts/header/Header";
import { UserData } from "../../routes/AppRoutes";
import { useDispatch, useSelector } from "react-redux";
import { apiClient } from "../../utils/apiClient";
import {
  setTermDataListDetails,
  setEventPointsListDetails,
  setTermDataOcSuccessRewards,
  setAcademicYearData,
} from "../../redux/TermDataReducer/TermDataSlice";
import {
  fetchEmployeeList,
  fetchEventpointsList,
  fetchTermCodeListGoalPoints,
} from "../../utils/service";
import {
  setActiveReward,
  setTermCodeValue,
} from "../../redux/RewardReducer/RewardsSlice";
import { setSnackbarDetails } from "../../redux/AuthReducer/AuthSlice";
import { getListTermCodes } from "../../utils/service";
import { RootState } from "../../store";
import { dispatchEmployeeListData } from "../../redux/EmployeeReducer/EmployeeSlice";

interface mainPageProps {
  setIsAuthenticated: (data: UserData | null) => void;
  children?: React.ReactNode;
}

const MainPage: React.FC<mainPageProps> = ({ setIsAuthenticated }) => {
  const dispatcher = useDispatch();
  const location = useLocation();
  const path = location?.pathname.split("/")[2];

  let { pagination } = useSelector((state: RootState) => state?.Employee);
  let { featureName } = useSelector((state: RootState) => state?.AuthCard);
  let { reportTabIndex } = useSelector((state: RootState) => state?.TftReport);

  //using the following useEffect to fetch the termCodeList which is used in multiplecomponents
  useEffect(() => {
    const listTermCodes = async () => {
      try {
        await getListTermCodes(dispatcher);
        // let activeWard = res?.find((item: any) => item.rewardToggleOn);
        // dispatcher(setTermDataListDetails(res));
        // dispatcher(setTermCodeValue(res?.[0]?.id));
        // dispatcher(setActiveReward(activeWard ?? null));
      } catch (error: any) {
        console.log(error);
        // dispatcher(
        //   setSnackbarDetails({
        //     type: "error",
        //     message:
        //       error.response?.data?.message ??
        //       "error in fetching the termCodesList!",
        //   }),
        // );
      }
    };
    if (featureName === "oc_all_in") {
      listTermCodes();
    }
  }, [dispatcher, featureName]);

  useEffect(() => {
    async function getTermCodeListGoalPoints() {
      try {
        let res = await fetchTermCodeListGoalPoints();
        dispatcher(setTermDataOcSuccessRewards(res?.ocSuccessRewards));
      } catch (error: any) {
        dispatcher(
          setSnackbarDetails({
            type: "error",
            message:
              error.response?.data?.message ??
              "error in fetching the termCodesListGoalPoints!",
          }),
        );
      }
    }
    if (featureName === "oc_all_in") {
      getTermCodeListGoalPoints();
    }
  }, [dispatcher, featureName]);

  //using the following useEffect to fetch the eventPointsList which is used in multiple components
  const getEventpointsList = useCallback(async () => {
    try {
      let res = await fetchEventpointsList(dispatcher);
      dispatcher(setEventPointsListDetails(res?.data?.data));
    } catch (error: any) {
      dispatcher(
        setSnackbarDetails({
          type: "error",
          message:
            error.response?.data?.message ??
            "error in fetching the eventPointsList!",
        }),
      );
    }
  }, [dispatcher]);

  useEffect(() => {
    async function getAcademicYearDetails() {
      try {
        let res = await apiClient?.get<any>(`/academic-year/list`);
        dispatcher(setAcademicYearData(res?.data?.data));
      } catch (error: any) {
        dispatcher(
          setSnackbarDetails({
            type: "error",
            message:
              error.response?.data?.message ??
              "error in fetching the academicYear details!",
          }),
        );
      }
    }
    if (featureName === "oc_all_in") {
      getAcademicYearDetails();
    }
  }, [dispatcher, featureName]);

  // useEffect(() => {
  //   async function fetchEmployees() {
  //     try {
  //       let res = await fetchEmployeeList(pagination, dispatcher);
  //       dispatcher(dispatchEmployeeListData(res));
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   }
  //   fetchEmployees();
  // }, [dispatcher]);

  useEffect(() => {
    if (featureName === "oc_all_in") {
      getEventpointsList();
    }
  }, [getEventpointsList, featureName]);

  return (
    <div className="main-layout">
      {/* <Header setIsAuthenticated={setIsAuthenticated} /> */}
      <div id="main-content" className="main-body">
        <div className="main-content-sidebar">
          <Sidebar />
        </div>
        <div className="main-content">
          <Header setIsAuthenticated={setIsAuthenticated} />
          <div
            className={`${location?.pathname === "/thirty-for-thirty/reports" && reportTabIndex === 4 ? "main-page" : "main-content-pages"}`}
          >
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainPage;
